import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, fw_progressive_1way, numberFormat, tooltip_class} from '../functions'

export default function (chart, divId, vizName, filterParam, checkbox) {
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    var metric1ColorScale = d3.scaleOrdinal().range(fw_progressive_1way)
    var x1Scale = d3.scaleLinear().range([0, chart.width])
    var y1Scale = d3.scaleBand().rangeRound([chart.height, 0])

    var x1AxisLabel = d3.axisBottom(x1Scale).tickSizeInner(-chart.height)
        .tickSizeOuter(-chart.height)
        .tickFormat(numberFormat)
        .ticks(3)

    var y1AxisLabel = d3.axisLeft(y1Scale).tickSizeInner(-chart.width).tickSizeOuter(-chart.width)
    var left1 = 4

    d3.select(".d3-tippcm" + divId.id).remove(); // clear tooltip based on class of tip element
    var y1tip = tooltip_class()

    y1tip.attr('class', 'd3-tip' + divId.id)
        .offset([-10, 0])
        .html(function (d) {
            return d.dim5_name == null ? d.dim2_name + "(" + d.dim1_name + ")"
                + colonAnnotation + numberFormat(d.metric1) + " " : " "
                + d.dim5_name + "(" + d.dim1_name + ")"
                + colonAnnotation + numberFormat(d.metric1)
        })

    axios.post(url, filterParam).then(res => {
        let data = res.data;

        // Data is nested by country
        var categories = d3.nest()
            .key(function (d) {
                return d.dim1_name;
            })
            .sortKeys(d3.ascending)
            .entries(data);

        categories.forEach(function (c) {
            c.values.forEach(function (d) {
                d.metric1 = +d.metric1;
            });
        });

        if (checkbox == true) {
            y1Scale.domain(data.map(function (d) {
                return d.dim2_name;
            }));

            div = d3.select(divId)
            div.selectAll("*").remove();

            div = d3.select(divId).selectAll("svg")
                .data(categories)
                .enter()
                .append("svg")
                .attr("width", function (d, i) {
                    return categories[i] == categories[0] ? chart.width + chart.margin.left + chart.margin.right : chart.width + left1 + chart.margin.right
                })
                .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
                //  .call(responsivefy)
                .append("g")
                .attr("transform", function (d, i) {
                    return categories[i] == categories[0] ? "translate(" + chart.margin.left + "," + chart.margin.top + ")" : "translate(" + left1 + "," + chart.margin.top + ")"
                })
                .attr("id", function (d) {
                    return d.key;
                })

            categories.forEach(function (d) {
                //CSS.escape(id) - will escape special character in id/key
                div = d3.select("#" + CSS.escape(d.key));
                x1Scale.domain([0, d3.max(d.values, function (d) {
                    return d.metric1
                })])

                div.append("g")
                    .attr("class", "x axis")
                    .attr('class', 'axis-grid')//adding grid style
                    .attr("transform", "translate(0," + chart.height + ")")
                    .call(x1AxisLabel)
                    .style('fill', '#E8E8E8')
                    .selectAll('text')
                    //.style('text-anchor', 'end')
                    .attr('dx', '-.01em')
                    //  .style("text-anchor", "start")
                    .attr("font-size", "15px")
                // .attr('transform', 'rotate(-50)')

                //adding axis labels
                div.append("text")
                    .attr("transform",
                        "translate(" + (chart.width / 2) + " ," +
                        (chart.height + chart.margin.top + 10) + ")")
                    .style("text-anchor", "middle")
                    .attr("font-size", "20px")
                    .text(chart.x1AxisDisplayName);

                div.append("g")
                    .attr("class", "y axis")
                    .attr('class', 'axis-grid')
                    .call(y1AxisLabel)
                    //      .attr("transform", "translate(" + x1Scale(d3.min(data,(d) =>{ return d.metric1})) + ",0)")
                    .selectAll('text')
                    //      .style("text-anchor", "start")
                    .attr("font-size", "15px")

                //adding axis labels
                div.append("text")
                    .attr("transform", "rotate(-90)")
                    .attr("x", 60 - (chart.height / 2))
                    .attr("y", 5)
                    // .attr("dy", "-em")
                    .style("text-anchor", "start")
                    .style('display', function (d, i) {
                        return categories[i] == categories[0] ? "block " : "none"
                    })
                    .text(chart.y1AxisDisplayName);

                //adding category name at right hand side
                div.append("g")
                    .append("text")
                    //.attr('transform', 'rotate(90)')
                    //.attr("x", width -6)
                    .attr("y", chart.width / 1.5)
                    .attr("dy", "-7em")
                    .attr("text-anchor", "start")
                    .attr("font-size", "20px")
                    // .style("fill", function (d) { return color(d.key) })
                    .text(function (d) {
                        return d.key
                    });

                div.selectAll(".dotpcm")
                    .data(function (d) {
                        return d.values;
                    })
                    .enter()
                    .append("circle")
                    .attr("class", "dotpcm")
                    .attr("r", 3)
                    .attr("cx", function (d) {
                        return x1Scale(d.metric1);
                    })
                    .attr("cy", function (d) {
                        return y1Scale(d.dim2_name);
                    })
                    .attr("fill", function (d) {
                        return d.dim5_name == null ? metric1ColorScale(d.dim2_name) : metric1ColorScale(d.dim5_name)
                    })
                    .on('mouseover', y1tip.show)
                    .on('mouseout', y1tip.hide)
                    //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding
                    .call(y1tip);
            });
        } else {
            x1Scale.domain([0, d3.max(data.map(function (d) {
                return d.metric1;
            }))]);
            y1Scale.domain(data.map(function (d) {
                return d.dim2_name;
            }));

            var div = d3.select(divId)
            div.selectAll("*").remove();
            var svg = d3.select(divId).selectAll("svg")
                .data(categories)
                .enter()
                .append("svg")
                .attr("width", function (d, i) {
                    return categories[i] == categories[0] ? chart.width + chart.margin.left + chart.margin.right : chart.width + left1 + chart.margin.right
                })
                .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
                //  .call(responsivefy)
                .append("g")
                .attr("transform", function (d, i) {
                    return categories[i] == categories[0] ? "translate(" + chart.margin.left + "," + chart.margin.top + ")" : "translate(" + left1 + "," + chart.margin.top + ")"
                })

            svg.append("g")
                .attr("class", "x axis")
                .attr('class', 'axis-grid')
                .attr("transform", "translate(0," + chart.height + ")")
                .call(x1AxisLabel)
                .style('fill', '#E8E8E8')
                .selectAll('text')
                //.style('text-anchor', 'end')
                .attr("font-size", "15px")
                .attr('dx', '-.01em')
            // .attr('transform', 'rotate(-50)')

            //adding axis labels
            svg.append("text")
                .attr("transform",
                    "translate(" + (chart.width / 2) + " ," +
                    (chart.height + chart.margin.top + 10) + ")")
                .style('display', function (d, i) {
                    return categories[i] == categories[categories.length / 2 - 1] ? "block " : "none"
                })
                .style("text-anchor", "middle")
                .attr("font-size", "20px")
                .text(chart.x1AxisDisplayName);

            svg.append("g")
                .attr("class", "y axis")
                .attr('class', 'axis-grid')
                .call(y1AxisLabel)
                .selectAll('text')
                //    .attr("text-anchor", "start")
                .attr("font-size", "15px")

            //adding axis labels
            svg.append("text")
                .attr("transform", "rotate(-90)")
                .attr("x", 60 - (chart.height / 2))
                .attr("y", 5)
                //     .attr("dy", "-4em")
                .style("text-anchor", "middle")
                .style('display', function (d, i) {
                    return categories[i] == categories[0] ? "block " : "none"
                })
                .attr("font-size", "20px")
                .text(chart.y1AxisDisplayName);

            //adding category name at right hand side
            svg.append("g")
                .append("text")
                .attr("y", chart.width / 1.5)
                .attr("dy", "-7em")
                .attr("text-anchor", "start")
                .attr("font-size", "20px")
                .text(function (d) {
                    return d.key
                });

            svg.selectAll(".dotpcm")
                .data(function (d) {
                    return d.values
                })
                .enter()
                .append("circle")
                .attr("class", "dotpcm")
                .attr("r", 3)
                .attr("cx", function (d) {
                    return x1Scale(d.metric1)
                })
                .attr("cy", function (d) {
                    return y1Scale(d.dim2_name)
                })
                .attr("fill", function (d) {
                    return d.dim5_name == null ? metric1ColorScale(d.dim2_name) : metric1ColorScale(d.dim5_name)
                })
                .on('mouseover', y1tip.show)
                .on('mouseout', y1tip.hide)
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

            svg.call(y1tip);
        }
        /*  var y1legend = d3.select(divId)
                          .append("svg")
                          .attr('class', 'legend')
                          .attr("width", chart.vizSpecific1)
                          .attr("height", 700)
                          .selectAll("g")
                          .data(metric1ColorScale.domain().reverse())
                          .enter()
                          .append("g")
                          .attr("transform", function (d, i) { return "translate(25," + i * 20 + ")"; });

           y1legend.append('rect')
                   .attr('x', chart.width/2)
                   .attr('width', 10)
                   .attr('height', 10)
                   .style('fill', metric1ColorScale)

            y1legend.append('text')
                   .attr('x', chart.width/2+ 10)
                   .attr("font-size","10px")
                   .attr('x', 25)
                   .attr('y', 9)
                   .attr('dy', '.35em')
                   .text(function (d) { return d })
        */
    });
}
